import type { ReactNode } from 'react'
import styles from './OCRScopeJobDetailBodyLegendInformation.module.css'
import { OCRScopeJobDetailBodyTitle } from '@/features/jobs/scoping/components/OCRScopeJobDetailBodyTitle'

export interface OCRScopeJobDetailBodyLegendInformationProps {
  children?: ReactNode
}

export function OCRScopeJobDetailBodyLegendInformation({
  children,
}: OCRScopeJobDetailBodyLegendInformationProps) {
  return (
    <div className={styles.root}>
      <OCRScopeJobDetailBodyTitle title={'Legend Information'} />

      <div className={styles.content}>{children}</div>
    </div>
  )
}
